import React, {useEffect, useMemo, useState} from 'react';
import styled from 'styled-components';
import Logo from '../../UI/Logo';
import UIButton from '../../UI/UIButton';
import {wh, MediumTitle, fadeInAnimation, screenPadding, fontSize, centeredFlex} from '../../mixins';
import { useTranslation } from 'react-i18next';
import PasswordInput from './PasswordInput';
import { useSelector, useDispatch } from 'react-redux';
import {selectPassword, selectSuccess, selectValidity, sendAPIRequest, setShowError} from './passwordSlice';
import {sendAnalyticsEvents} from '../../analytics/common';
import {EVENTS} from '../../analytics/events';
import {selectEventsData} from '../events/eventsSlice';
import {selectToken} from '../signup/signupSlice';
import ModalPopup from '../../UI/ModalPopup';
import UpsellPopup from '../plans/UpsellPopup';
import {selectLandingType} from '../plans/plansSlice';
import { browserName, isBrowser } from 'react-device-detect';
import useWindowWidth from '../../helper/useWindowWidth';


const StyledSignup = styled.div`
  ${centeredFlex};
  ${screenPadding};
  min-height: 100%;
  ${isBrowser && fadeInAnimation};
  justify-content: center;
  
  img {
      margin: ${props => props.windowWidth <= 430 && props.isFB ? '130px 0 0' : '0 0 111px'};
  }
  @media screen and (max-width: 430px) {
    justify-content: ${props => props.isFB ? 'flex-start' : 'center'};
  }
`;

const Title = styled.h1`
  ${MediumTitle};
  margin-top: 0px;
  margin-bottom: 30px;
  @media screen and (max-width: 768px){
    ${fontSize(24)};
  }

`;

const StyledBtn = styled.button`
  background-color: transparent;
  border: none;
  display: inline-block;
  color: #fff;
  cursor: pointer;
  ${fontSize(12)};
  line-height: 18px;
  letter-spacing: -0.128px;
  font-weight: 300;
  text-decoration: underline;
  
  &:focus,
  &:active {
    outline: none;
  }
`;

const StyledText = styled.p`
  ${fontSize(12)};
  ${wh('90%', 'auto')};
  line-height: 18px;
  color: #fff;
  letter-spacing: -0.128px;
  text-align: center;
  font-weight: 300;
  margin: 0 0 23px;
  @media screen and (max-width: 430px) {
    margin-bottom: ${props => props.isFB ? '18px' : '23px'};
  }
  
  a {
    text-decoration: underline;
  }
`;

const ContentBlock = styled.div`
  ${centeredFlex};
  width: 100%;
`;

const PasswordScreen = ({history}) => {

    const { t } = useTranslation();
    const isValid = useSelector(selectValidity);
    const pass = useSelector(selectPassword);
    const isSuccess = useSelector(selectSuccess);
    const eventsData = useSelector(selectEventsData);
    const token = useSelector(selectToken);
    const landingType = useSelector(selectLandingType);
    const dispatch = useDispatch();
    const [upsellShow, setUpsellShow] = useState(false);
    const hideUpsellFor = useMemo(() => ['family'], []);
    const windowWidth = useWindowWidth();
    const isFB = (landingType === 'option_c' || landingType === 'option_b2') && browserName === 'Facebook';

    const onBtnClick = () => {
        if (isValid) {
            sendAnalyticsEvents(EVENTS.passwordRequestSent, eventsData);
            dispatch(sendAPIRequest(pass, token));
        } else {
            dispatch(setShowError(true));
        }
    };

    const onUpsellClose = () => {
        setUpsellShow(false);
        sendAnalyticsEvents(EVENTS.upsellTappedClose, eventsData);
    };

    useEffect(() => {
        if (!hideUpsellFor.includes(landingType)) {
            // setTimeout(() => setUpsellShow(true), 500);
            console.log('upsell was disabled');
        }
    }, [landingType, hideUpsellFor]);

    useEffect(() => sendAnalyticsEvents(EVENTS.passwordScreenShown, eventsData), [eventsData]);


    useEffect(() => {
        if (isSuccess) {
            sendAnalyticsEvents(EVENTS.passwordSuccess, eventsData);
            history.push('/checkout/success');
        }
    }, [isSuccess, history, eventsData]);


    const onLinkClick = url => window.open(url);


    return (
        <StyledSignup windowWidth={windowWidth} isFB={isFB}>
            {(windowWidth > 430 || (windowWidth <= 430 && !isFB)) && <Logo/>}
            <ContentBlock>
                <Title>{t('create_password')}</Title>
                <PasswordInput id={'password-input'}/>
                <PasswordInput confirm id={'confirm-password-input'}/>
                <StyledText isFB={isFB}>
                    <span>{t('privacy_note')}</span>
                    <StyledBtn onClick={() => onLinkClick('https://geozilla.com/terms-of-use/')} id="link-to-terms">{t('terms')}</StyledBtn>
                    <span>{t('and')}</span>
                    <StyledBtn onClick={() => onLinkClick('https://geozilla.com/privacy-policy/')} id="link-to-privacy">{t('privacy')}</StyledBtn>
                </StyledText>
                <UIButton onClick={onBtnClick} inactive={!isValid}>{t('continue')}</UIButton>
                {windowWidth <= 430 && isFB && <Logo/>}
            </ContentBlock>
            <ModalPopup show={upsellShow} onClose={onUpsellClose}>
                <UpsellPopup closePopup={() => setUpsellShow(false)}/>
            </ModalPopup>
        </StyledSignup>
    );
};

export default PasswordScreen;